import { useMutation } from "@tanstack/react-query";
import type { InferRequestType } from "hono";
import { handleError } from "@/api/error";
import { queryClient } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

// Inferred from the route so the `role` enum stays in lock-step (UNB-1912).
type UpdateUserPayload = InferRequestType<(typeof client.admin.user)[":id"]["$patch"]>["json"];
export const useUpdateUser = (id: string) => {
  return useMutation({
    mutationFn: async (payload: UpdateUserPayload) => {
      const res = await client.admin.user[":id"].$patch({
        param: {
          id,
        },
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "users"] });
    },
  });
};
